import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import useEditorOptionsList from '@/modules/corporate/modules/questions/fields/hooks/useEditorOptionsList';
import { QuestionEditorProps } from '@/modules/corporate/modules/questions/fields/types';

import EditorOptionsListItem from './components/EditorOptionsListItem';

function EditorOptionsList(props: QuestionEditorProps) {
  const { viewMode, className } = props;
  const { options, onAction } = useEditorOptionsList(props);

  return (
    <Stack className={cn('space-s-12', className)} direction="row" justifyContent="between">
      {options.map((option, index) => (
        <EditorOptionsListItem
          key={`optionItem_${index}`}
          className="flex-1"
          index={index}
          option={option}
          viewMode={viewMode}
          onAction={onAction}
        />
      ))}
    </Stack>
  );
}

export default EditorOptionsList;
